import React from "react";
import Navbar from "../Navbar";

const Services = () => {
  return (
    <>
      <Navbar />

      <div className="main-about-container">
        <h1 style={{ color: "black" }}>Services</h1>
        <div
          style={{
            borderBottom: "2px solid red",
            margin: "auto",
            width: "8%",
            marginTop: "1rem",
          }}
        ></div>

        <div
          style={{
            margin: "auto",
            marginTop: "4rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
          }}
        >
          Ignite the efficiency of your machinery with GURURAJ SPARES – your
          trusted partner for top-quality spare parts and exceptional services.
          Our comprehensive range of services includes personalized
          consultations, precise customization, seamless installations, expert
          maintenance, and prompt repairs. With a commitment to excellence, we
          deliver solutions that optimize performance, reliability, and
          longevity. Experience a new level of service and support as we fuel
          your success and keep your machines running at their peak. Trust
          GURURAJ SPARES to be your partner in driving productivity and
          achieving unmatched results.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "5rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Spare Parts Sales</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          We provide a wide selection of high-quality spare parts for various
          applications. Whether you need automotive parts, industrial machinery
          components, or specialized equipment parts, we have you covered. Our
          extensive inventory is carefully curated to offer you reliable and
          durable options from reputable manufacturers.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Expert Consultation</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          Our experienced team is always ready to provide expert consultation
          and guidance. If you have specific requirements or are unsure about
          the right spare part for your machinery, we are here to assist you. We
          will listen to your needs, analyze your situation, and offer
          personalized recommendations to help you make informed decisions.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Customization</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          We understand that some machinery and equipment require specialized
          parts that may not be readily available in the market. That's why we
          offer customization services to meet your unique requirements. Our
          skilled technicians and engineers can work with you to develop
          tailored solutions that perfectly fit your machinery and deliver
          optimal performance.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Order Tracking and Support</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          We believe in transparency and keeping you informed throughout the
          process. Once you place an order with us, we provide order tracking
          services, allowing you to stay updated on the progress and estimated
          delivery time. Additionally, our customer support team is available to
          assist you with any inquiries or concerns regarding your order.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Warranty and Returns</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          We stand behind the quality of our spare parts and want you to be
          completely satisfied with your purchase. We offer warranty coverage
          for eligible products, providing you with peace of mind. If, for any
          reason, you need to return or exchange a product, our team will guide
          you through the process and ensure a smooth resolution.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Bulk Orders and Wholesale</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          For businesses or individuals requiring larger quantities of spare
          parts, we offer bulk ordering and wholesale services. Our competitive
          pricing and flexible terms make it convenient for you to stock up on
          the parts you need while saving on costs.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>
            Diesel Exhaust Fluid (DEF) Pump Services
          </h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          We specialize in Diesel Exhaust Fluid (DEF) pump services to meet your
          specific needs in this area. DEF is a critical component for modern
          diesel engines, and our DEF pump services are tailored to ensure the
          proper handling and dispensing of DEF fluid. Our range of DEF pump
          services includes: DEF Pump Sales: We offer a selection of DEF pumps
          designed for accurate and efficient dispensing of DEF fluid. Whether
          you require a portable DEF pump for personal use or an
          industrial-grade pump for commercial applications, we have options to
          suit your requirements.
          <div style={{ marginTop: "2rem" }}>
            Installation and Setup: Our team of experts can assist with the
            proper installation and setup of your DEF pump. We understand the
            importance of correct installation to ensure optimal performance and
            prevent any potential issues. We provide professional guidance and
            support to ensure your DEF pump is installed correctly and ready for
            operation.
          </div>
          <div style={{ marginTop: "2rem" }}>
            Maintenance and Repair: Regular maintenance is essential for the
            longevity and smooth operation of your DEF pump. Our technicians
            provide routine inspections, cleaning, and troubleshooting services
            to identify and address any potential issues. In the event of a pump
            malfunction or breakdown, we offer prompt repair services to
            minimize downtime and get your DEF pump back in working condition.
          </div>
          <div style={{ marginTop: "2rem" }}>
            DEF Pump Accessories and Parts: We stock a wide range of DEF pump
            accessories and parts to support your pump system. From hoses and
            nozzles to fittings and filters, we have the necessary components to
            maintain and enhance the functionality of your DEF pump. Our
            selection of genuine parts ensures compatibility and reliability.
          </div>
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Disclaimer of Warranties</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          At GURURAJ SPARES, we strive to provide accurate and reliable
          information and services. However, we make no warranties or
          representations regarding the accuracy, completeness, reliability, or
          suitability of the information, products, or services provided on our
          website. We do not guarantee that our services will be uninterrupted,
          error-free, or free from viruses or other harmful components. Any
          reliance you place on our services is at your own risk.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Limitation of Liability</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          In no event shall GURURAJ SPARES or its affiliates, partners,
          directors, employees, or agents be liable for any direct, indirect,
          incidental, special, or consequential damages arising out of or in
          connection with the use of our services or the inability to use our
          services. This includes, but is not limited to, damages for loss of
          profits, data, or other intangible losses, even if we have been
          advised of the possibility of such damages. You agree that our total
          liability, regardless of the cause of action, shall not exceed the
          total amount paid by you, if any, for the use of our services.
        </div>

        <div
          style={{
            margin: "auto",
            marginTop: "3rem",
            marginBottom: "3rem",
            width: "80%",
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ marginBottom: "1rem" }}>Prohibited Uses</h2>
          <div
            style={{
              borderBottom: "2px solid red",
              width: "19%",
              marginTop: "1rem",
              marginBottom: "2rem",
              alignItems: "left",
            }}
          ></div>
          Unauthorized Access: You agree not to access or attempt to access any
          unauthorized areas of our website or servers. Any attempt to gain
          unauthorized access may result in legal action.
          <div style={{ marginTop: "2rem" }}>
            Intellectual Property Infringement: You agree not to use our
            services for any purpose that infringes upon or violates the
            intellectual property rights of others. This includes unauthorized
            copying, distribution, or use of copyrighted materials or trademarks
            without proper authorization.
          </div>
          <div style={{ marginTop: "2rem" }}>
            Malicious Activities: You agree not to use our services for any
            malicious activities, including but not limited to transmitting
            viruses, malware, or other harmful code, engaging in hacking or
            unauthorized access, or conducting any activity that disrupts or
            interferes with the functioning of our website or services
          </div>
          <div style={{ marginTop: "2rem" }}>
            Illegal Use: You agree not to use our services for any illegal or
            unauthorized purposes, including but not limited to engaging in
            fraudulent activities, transmitting illegal content, or violating
            any applicable laws or regulations.
          </div>
          <div style={{ marginTop: "2rem" }}>
            Misuse of Personal Information: You agree not to collect, store, or
            misuse personal information of other users of our website or
            services without their explicit consent.
          </div>
          <div style={{ marginTop: "2rem" }}>
            At GURURAJ SPARES, we strive to exceed your expectations with our
            top-notch services. Whether you are a professional in the industry
            or a passionate DIY enthusiast, we are committed to providing you
            with the support and solutions you need for a seamless experience.
            Contact us today to explore how we can assist you in fulfilling your
            spare parts requirements. Please read our Terms of Service for
            further details regarding the use of our website and services. By
            using our services, you agree to comply with all applicable laws and
            regulations and to refrain from engaging in any prohibited
            activities.
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
